import LOGO from "../images/UT.png";

export const Team__UT = {
  name: "UT Paquime",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#18ffc5ff",
  teamJerseyColor: "#FFBA00",

  // Stats
  gamesWon: 3,
  gamesLost: 0,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 52 + 63 + 47,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 56 + 65 + 53,
    },
  ],
};
